import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import TableWrapper from "../../core/BaseComponents/TableWrapper/TableWrapper";
import dayjs from "dayjs";
import { Tooltip, CircularProgress, Switch } from "@mui/material";
import { MdModeEditOutline } from "react-icons/md";
import { callAPI } from "../../../axios";
import DeleteIcon from "@mui/icons-material/Delete";
import BasicModal from "../../core/BaseComponents/Modal";
import { RiHotelBedFill } from "react-icons/ri";
import { getChainIdLS, isValidRole, ScrollToTop } from "../../../utils/utils";
import DeleteRoomTypeConfig from "./DeleteRoomTypeConfig";
import EnableDisableRoomType from "./EnableDisableRoomType";
import Custom_Paingation from "../../core/BaseComponents/Custom_Paingation";
import { useSelector } from "react-redux";

function RoomTypeConfiguration() {
  const [partnerConfigList, setPartnerConfigList] = useState([]);
  const [confirmDeletePartnerRow, setConfirmDeletePartnerRow] = useState("");
  const [confirmValidate, setConfirmValidate] = useState(false);
  const [deletePartnerPopUp, setDeletePartnerPopUp] = useState(false);
  const [editPartnerConfig, setEditPartnerConfig] = useState(false);
  const [editPartnerRowUpdate, setEditPartnerRowUpdate] = useState(false);
  const [createPartnerSuccessMsg, setCreatePartnerSuccessMsg] = useState('');
  const [editPartnerSid, setEditPartnerSid] = useState("");
  const [loader, setLoader] = useState(false);

  const [selectedPage, setSelectedPage] = useState(1);
  const [totalPageCount, setTotalPageCount] = useState(1);
  const [paginationError, setPaginationError] = useState("")
  const [inputPageValue, setInputPageValue]  =useState(1)

  const recordsPerPage = 10;

  const {chainId} = useSelector((state) => state.chainIdReducer);
  let validPermissionClassName = isValidRole("MASTER_CONFIG_ROOM_TYPE_MODIFY")
    ? ""
    : "btn-disable-permission";
 
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch
  } = useForm({
    mode: 'onChange',
    defaultValues: { active: true }
  });

  const onSubmit = (data) => {
    let method = "POST";
    let url = `/room-types`;
    if (editPartnerRowUpdate) {
      method = "PUT"
      url = `/room-types?sid=${editPartnerSid?.id}`;
    }
    callAPI(url, method, data, { chainId: getChainIdLS() })
      .then(function (response) {
        setLoader(false);
        reset({
          roomType: '',
          active: true
        });
        setCreatePartnerSuccessMsg(response?.message);
        PartnerListApi();
      })
      .catch(function (error) {
        setLoader(false);
        console.warn(error.response?.data?.errorMessage);
      });
  };

  const isPartnerDeletedRef = useRef({
    isPartnerDeletedModalData: null,
    userConformationModalData: null,
  });

  const deletePartnerConfigPopUpHandler = (row) => {
    setDeletePartnerPopUp(true);
    const newModalRefData = {
      isPartnerDeletedModalData: {
        row
      },
      userConformationModalData: null,
    };
    isPartnerDeletedRef.current = newModalRefData;
  }

  const deletePartnerHandler = () => {
    setConfirmValidate(true);
    if (confirmDeletePartnerRow === "") {
      return
    }

    if (confirmDeletePartnerRow === `Delete ${isPartnerDeletedRef.current?.isPartnerDeletedModalData.row.roomType}`) {
      setConfirmValidate(false)
      const { row } = isPartnerDeletedRef.current?.isPartnerDeletedModalData;
      callAPI(`/room-types?sid=${row?.id}`, "DELETE")
        .then((response) => {
          let successMessage = response.message
          const newModalRefData = {
            isPartnerDeletedModalData: null,
            userConformationModalData: {
              successMessage
            },
          };
          isPartnerDeletedRef.current = newModalRefData;
          PartnerListApi();
        })
        .catch((error) => {
          setDeletePartnerPopUp(false);
          console.warn(error)
        });
    }
    reset({
      roomType: '',
      active: true
    });
  }

  const renderActionIcon = (row) => {
    return (
      isValidRole("MASTER_CONFIG_ROOM_TYPE_MODIFY")?<>
        {!row?.active?<><Tooltip title="Edit" arrow>
          <MdModeEditOutline
            className="edit-icon-enable"
            onClick={() => { setEditPartnerConfig(true); setEditPartnerSid(row) }}
          />
        </Tooltip>
        <Tooltip title="Delete" className="cursor-pointer" arrow>
          <DeleteIcon
            className="delete-icon-enable"
            onClick={() => {
              deletePartnerConfigPopUpHandler(row);
            }}
          />
        </Tooltip></>:
          <>
          <Tooltip title="Disable to perform actions" arrow>
            <span><MdModeEditOutline className="edit-icon-disable" /></span>
          </Tooltip>
          <Tooltip title="Disable to perform actions" arrow>
            <DeleteIcon className="delete-icon-disable"/>
        </Tooltip>
          </>
        }
        <EnableDisableRoomType row={row} setLoader={setLoader} PartnerListApi={PartnerListApi}/>
      </>:<>
            <Tooltip title="Don't have permission to edit">
                <span>
                    <MdModeEditOutline className="edit-icon-disable" arrow />
                </span>
            </Tooltip>
            <Tooltip title="Don't have permission to delete">
                <DeleteIcon className="delete-icon-disable" arrow />
            </Tooltip>
            <Tooltip title="Don't have permission to edit">
                <span>
                <Switch
                name="active"
                disabled={true}
                // onChange={(event) => handleToggleChange(event, props?.row)}
                inputProps={{ "aria-label": "controlled" }}
                value={row.active}
                checked={row.active}
                className={`${row.active === false ? 'switchuser-inactive' : 'switchuser-active'}`}
                />
                </span>
        </Tooltip>
        </>
    );
  };

  const columns = [
    { field: "createdDate", headerName: "Created On", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{dayjs(row.createdOn).format("DD MMM YYYY | HH:mm")}</p> },
    { field: "roomType", headerName: "Room Type", flex: 1 },
    {
      field: "actionCell",
      row: true,
      headerName: "Actions",
      flex: 0.5,
      renderCell: renderActionIcon,
      sortDirection: false,
      disableSortIcon: true,
    },
  ];

  //Pagination Handle changer
  const onPageChange = (event, value) => {
    setInputPageValue(value)
    setPaginationError("")
    setSelectedPage(value);
  };

  const PartnerListApi = () => {
    // const apiPath = `banner/search?pageNo=${selectedPage}&recordsPerPage=${recordsPerPage}`;
    callAPI(`/master-room-types?pageNo=${selectedPage}&recordsPerPage=${recordsPerPage}`, "POST",{}, { chainId: getChainIdLS() })
      .then((response) => {
        setTotalPageCount(response?.totalPages?response?.totalPages:1)
        setPaginationError("")
        setPartnerConfigList(response?.roomTypeResponse )
        // setTotalPageCount(response?.totalPages)
        // setPaginationError("")
      })
      .catch((err) => console.warn(err.message));
  };

  useEffect(() => {
    PartnerListApi();
    cancelPartnerHandler()
  }, [selectedPage, chainId]);


  const popupCloseHandler = () => {
    setDeletePartnerPopUp(false);
  };


  useEffect(() => {
    if (editPartnerConfig) {
      getPartnerListSidHandler();
      setEditPartnerConfig(false);
    }
    ScrollToTop();
  }, [editPartnerConfig]);

  const getPartnerListSidHandler = () => {
    callAPI(`/room-types-id?sid=${editPartnerSid?.id}`, "GET")
      .then(function (response) {
        const payload = {
          roomType: response?.roomType,
          active: response?.active,
        };
        reset(payload);
        setEditPartnerRowUpdate(true);
      })
      .catch(function (error) {
        console.warn(error.response?.data?.errorMessage);
      });
  }

  const resetLayoutHandler = () => {
    reset();
  }

  const cancelPartnerHandler = () => {
    reset({
      roomType: '',
      active: true
    });
    setEditPartnerRowUpdate(false);
    setEditPartnerSid('');
    setEditPartnerConfig(false);
  }

  const handleSwitchChange = (checked) => {
    setValue("active", checked);
  };

  return (
    <div className='row config-hotel config-management-form'>
      <div className='col-12 left-column'>
        {loader && <div className="circular-progress"><CircularProgress /></div>}
        <form autoComplete="off" onSubmit={handleSubmit(onSubmit)} className="hotel-list-form">
          <div className="row">
            <div className="left-column-header">
              <p className="Roboto-Bold">{editPartnerRowUpdate ? 'Edit Room Type Configuration' : 'Room Type Configuration'}</p>
            </div>
            <div className="col-6">
              <div className="form-group-hotel">
                <div className="floating-label">
                  <RiHotelBedFill className="new-hotel-icons" />
                  <input
                    id="roomType"
                    maxLength={25}
                    placeholder=""
                    {...register("roomType", {
                      required: "Room Type Required",
                    })}
                  />
                  <label htmlFor="roomType">Room Type Name</label>
                </div>
                {errors.roomType && (
                  <small className="required">{errors.roomType.message}</small>
                )}
              </div>
              <div className="status-switch">
                <p className="mb-0">Room Type Status</p>
                <label htmlFor="active">{!watch("active") ? "Disabled" : "Enabled"}</label>
                <Switch
                  id="active"
                  className={`form-control border-0 ${!watch("active")
                    ? "switchuser-inactive"
                    : "switchuser-active"
                    }`}
                  checked={watch("active")}
                  onChange={handleSwitchChange}
                  {...register("active")}
                />
              </div>
            </div>
          </div>
          <div className="text-end mt-3">
            <button type="button" className="clear-btn me-2" onClick={cancelPartnerHandler}>{editPartnerRowUpdate ? "Cancel" : "Clear All"}</button>
            {editPartnerRowUpdate && <>
              <button type="button" className="clear-btn me-2" onClick={resetLayoutHandler}>Reset</button>
            </>}
            <button type="submit" className={`create-btn ${validPermissionClassName} `}>{editPartnerRowUpdate ? "Update" : "Create"}</button>
          </div>
        </form>
        <div className="hotel-list">
          <p><b>Room Type Configuration List</b></p>

          <TableWrapper
            data={partnerConfigList}
            columns={columns}
            noPagination={true}
            module="partner-config"
          />
          <Custom_Paingation
            selectedPage={selectedPage}
            totalPageCount={totalPageCount}
            paginationError={paginationError}
            inputPageValue={inputPageValue}
            setSelectedPage={setSelectedPage}
            setPaginationError={setPaginationError}
            setInputPageValue={setInputPageValue}
            onPageChange={onPageChange}
          />
        </div>
      </div>
      {deletePartnerPopUp && <DeleteRoomTypeConfig
        deletePartnerPopUp={deletePartnerPopUp}
        isPartnerDeletedRef={isPartnerDeletedRef}
        popupCloseHandler={popupCloseHandler}
        deletePartnerHandler={deletePartnerHandler}
        setConfirmDeletePartnerRow={setConfirmDeletePartnerRow}
        confirmDeletePartnerRow={confirmDeletePartnerRow}
        confirmValidate={confirmValidate}
      />}
      <BasicModal
        popupOpen={createPartnerSuccessMsg !== ""}
        logo={"/Images/approve-qc.png"}
        bodyMessage={<p className="mt-2">{createPartnerSuccessMsg}</p>}
        footer={
          {
            secondaryButton: {
              buttonName: "OK",
              action: () => { setCreatePartnerSuccessMsg(''); setEditPartnerRowUpdate(false); PartnerListApi(); },
              buttonPrimaryCustomCss: 'cancel-btn_new'
            }
          }
        }
      />
    </div>
  )
}

export default RoomTypeConfiguration;